/* pd-r8: round D on product pages (2026-10-05, Abhi: "do the recommended"). Loaded by sections/main-product.liquid.
   [R8-3] Phone photo viewer. On phones and tablets the theme's zoom button opened a 2x crop pinned to a corner of the photo,
          mostly tabletop. Now a tap on a product photo (or the zoom button) opens every photo full screen, fitted: swipe between
          them, "2 / 4" at the top, pinch or double-tap to zoom (then drag to look around), swipe down or X to close. On closing,
          the page gallery moves to the photo you were on. Desktop (mouse) keeps the theme's hover zoom.
   [R8-2] "Compare sizes" on Diwali boxes (button under the price, snippets/pd-unit-price.liquid): a sheet with each box size's
          price and about-price per 100 g, the size with the lowest price per 100 g marked, this box marked, and every box listed
          by price per 100 g. Data comes from the live product records on the page (no prices are typed here); weights are the
          "Approx." net weights, so every figure says "about".
   [R9-5] 5 Oct 2026 (Abhi: "do all"): the viewer grows out of the photo you tapped and shrinks back into the gallery when it closes
          (X or swipe down; a quick flick is enough). [R9-1] the Compare sizes sheet slides away instead of vanishing. Esc closes
          both at once (keyboard actions are never animated). Reduced motion: no growing, no sliding.
   Styles: assets/pd-r8.css. Both use the native <dialog>: focus stays inside, Esc closes, focus returns. */
(function () {
  'use strict';
  var d = document, w = window;
  if (!w.HTMLDialogElement || !('showModal' in d.createElement('dialog'))) return;
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function el(t, c, h) { var e = d.createElement(t); if (c) e.className = c; if (h != null) e.innerHTML = h; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function safe(f) { try { f(); } catch (e) { if (w.console) console.warn('[pd-r8]', e); } }
  var RM = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function TOUCH() { return !!(w.matchMedia && w.matchMedia('(hover: none)').matches); }
  function sized(u, px) { u = String(u || '').replace(/^https?:/, ''); return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + px; }
  var X_ICON = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  function lockPage(on) { d.documentElement.classList.toggle('pd-modal-open', !!on); }
  var IN = 'cubic-bezier(.22,1,.36,1)', OUT = 'cubic-bezier(.32,0,.67,0)';

  /* ---------- [R8-3] photo viewer ---------- */
  function viewer() {
    var gal = $('[data-js-product-gallery]'); if (!gal) return;
    var seen = {}, list = [];
    $$('.product-gallery-item[data-product-media-type="image"]', gal).forEach(function (it) {
      var id = it.getAttribute('data-media-id'); if (!id || seen[id]) return; seen[id] = 1;
      var z = $('product-image-zoom', it), im = $('img', it);
      var src = z ? z.getAttribute('data-image') : (im && (im.getAttribute('data-src') || im.currentSrc || im.src));
      if (src) list.push({ id: id, src: src.replace(/[?&]width=\d+/, ''), alt: im ? (im.getAttribute('alt') || '') : '', el: it });
    });
    if (!list.length) return;
    var title = ($('.product-text h1') || $('h1') || {}).textContent || 'this product';
    title = title.replace(/\s+/g, ' ').trim();
    var dlg = null, track, slides = [], countEl, dots, idx = 0, opener = null;
    var Z = { s: 1, x: 0, y: 0 };

    function build() {
      dlg = el('dialog', 'pd-pv');
      dlg.setAttribute('aria-label', 'Photos of ' + title);
      var n = list.length;
      dlg.innerHTML = '<div class="pd-pv__top"><p class="pd-pv__count" aria-live="polite"><span>1</span> / ' + n + '</p>'
        + '<button type="button" class="pd-pv__x" aria-label="Close photos">' + X_ICON + '</button></div>'
        + '<div class="pd-pv__track">' + list.map(function (p, i) {
            return '<figure class="pd-pv__slide" role="group" aria-roledescription="slide" aria-label="Photo ' + (i + 1) + ' of ' + n + '"><div class="pd-pv__zoom"><img alt="' + esc(p.alt) + '" decoding="async" draggable="false"></div></figure>';
          }).join('') + '</div>'
        + (n > 1 ? '<div class="pd-pv__bar"><button type="button" class="pd-pv__nav" data-d="-1" aria-label="Previous photo"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
          + '<div class="pd-pv__dots" aria-hidden="true">' + list.map(function () { return '<i></i>'; }).join('') + '</div>'
          + '<button type="button" class="pd-pv__nav" data-d="1" aria-label="Next photo"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button></div>' : '<div class="pd-pv__bar"></div>')
        + '<p class="pd-pv__hint" aria-hidden="true">Pinch or double-tap to zoom</p>';
      d.body.appendChild(dlg);
      track = $('.pd-pv__track', dlg); slides = $$('.pd-pv__slide', dlg); countEl = $('.pd-pv__count span', dlg); dots = $$('.pd-pv__dots i', dlg);
      $('.pd-pv__x', dlg).addEventListener('click', function () { shut(); });
      $$('.pd-pv__nav', dlg).forEach(function (b) { b.addEventListener('click', function () { go(idx + (+b.getAttribute('data-d'))); }); });
      dlg.addEventListener('close', onClose);
      dlg.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); } });
      dlg.addEventListener('gesturestart', function (e) { e.preventDefault(); });
      var raf = 0;
      track.addEventListener('scroll', function () {
        if (raf) return; raf = requestAnimationFrame(function () { raf = 0; var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (i !== idx) setIdx(i); });
      }, { passive: true });
      gestures();
    }
    /* [R9-5] start from the photo the page has already loaded (so the grow-out shows it at once), then swap in a sharper one */
    /* the theme's slider rebuilds its slides after load, so always look the photo up again (the first one that is drawn) */
    function itemEl(i) {
      if (!list[i]) return null;
      var all = $$('.product-gallery-item[data-media-id="' + list[i].id + '"]', gal);
      var vw = w.innerWidth, best = null;
      for (var k = 0; k < all.length; k++) {
        if (!all[k].getClientRects().length) continue;
        var r = all[k].getBoundingClientRect();
        if (r.left > -10 && r.right < vw + 10) return all[k];   /* the one on screen */
        if (!best) best = all[k];
      }
      return best || all[0] || list[i].el;
    }
    function pageImg(i) { var it = itemEl(i), g = it && $('img', it); return (g && g.complete && g.naturalWidth) ? g : null; }
    function load(i) {
      var s = slides[i]; if (!s) return; var im = $('img', s); if (im.getAttribute('src')) return;
      var u = list[i].src, g = pageImg(i), hi = sized(u, 1600);
      if (g && (g.currentSrc || g.src)) {
        im.setAttribute('src', g.currentSrc || g.src);
        var pre = new Image(); pre.decoding = 'async';
        pre.onload = function () { if (!im.getAttribute('data-hi')) im.setAttribute('src', hi); };
        pre.src = hi;
      } else im.setAttribute('src', hi);
    }
    function setIdx(i) {
      if (Z.s !== 1) reset(false);
      idx = Math.max(0, Math.min(list.length - 1, i));
      countEl.textContent = String(idx + 1);
      dots.forEach(function (o, k) { o.classList.toggle('is-on', k === idx); });
      load(idx); load(idx + 1); load(idx - 1);
    }
    function go(i) {
      i = Math.max(0, Math.min(list.length - 1, i)); if (i === idx && Z.s === 1) return;
      track.scrollTo({ left: i * track.clientWidth, behavior: RM ? 'auto' : 'smooth' }); setIdx(i);
    }
    function open(i, from) {
      if (!dlg) build();
      opener = from || d.activeElement;
      lockPage(true);
      dlg.classList.remove('is-dragging', 'is-closing'); dlg.style.removeProperty('--pd-pv-fade'); track.style.transform = '';
      dlg.showModal();
      track.scrollTo({ left: i * track.clientWidth, behavior: 'auto' });
      idx = -1; setIdx(i);
      growFrom(i, from);
      try { if (!sessionStorage.getItem('pd-pv-hint')) { dlg.classList.add('show-hint'); sessionStorage.setItem('pd-pv-hint', '1'); setTimeout(function () { dlg.classList.remove('show-hint'); }, 2600); } } catch (e) {}
      $('.pd-pv__x', dlg).focus({ preventScroll: true });
    }
    function syncGallery() {
      var item = itemEl(idx), sl = $('css-slider', gal);
      if (item && sl && sl.sliderEnabled && sl.changeSlide) { try { sl.changeSlide(item.getAttribute('data-index'), 'auto'); } catch (e) {} }
    }
    function onClose() {
      reset(false); lockPage(false); syncGallery();
      /* drop the held end-frames of the closing motion, or the next opening starts from them */
      [dlg].concat($$('img, .pd-pv__top, .pd-pv__bar, .pd-pv__track', dlg)).forEach(function (x) { if (x.getAnimations) x.getAnimations().forEach(function (a) { a.cancel(); }); });
      dlg.classList.remove('is-dragging', 'is-closing', 'is-morph'); dlg.style.removeProperty('--pd-pv-fade'); track.style.transform = ''; closing = false;
      var o = opener; opener = null;
      if (o && o.focus && d.body.contains(o)) { try { o.focus({ preventScroll: true }); } catch (e) {} }
    }

    /* ---------- [R9-5] grow out of the tapped photo, shrink back into the gallery ----------
       The photo element fills its slide with object-fit: contain, so the drawn photo is a centred box inside it. A transform
       (translate + scale) moves that box onto the page photo, and a clip-path trims it to the page photo's crop and rounded
       corners; both run to nothing. Only transform, clip-path and opacity move. */
    var closing = false;
    function ratioOf(i) {
      var im = $('img', slides[i]), g = pageImg(i);
      if (im && im.naturalWidth && im.naturalHeight) return im.naturalWidth / im.naturalHeight;
      if (g) return g.naturalWidth / g.naturalHeight;
      var it = itemEl(i); return (it && +it.getAttribute('data-ratio')) || 1;
    }
    function pageRect(i) { /* the page photo's content box (the gallery can pad its photos) */
      var it = itemEl(i); if (!it) return null;
      var g = $('img', it) || it, r = g.getBoundingClientRect(), vh = w.innerHeight, cs = getComputedStyle(g);
      var pt = parseFloat(cs.paddingTop) || 0, pr = parseFloat(cs.paddingRight) || 0, pb = parseFloat(cs.paddingBottom) || 0, pl = parseFloat(cs.paddingLeft) || 0;
      var b = { left: r.left + pl, top: r.top + pt, width: r.width - pl - pr, height: r.height - pt - pb };
      if (b.width < 20 || r.bottom < 8 || r.top > vh - 8) return null; /* off screen: just fade */
      return b;
    }
    function frames(i, S) {
      var s = slides[i], B = s.getBoundingClientRect(), r = ratioOf(i);
      var tw = Math.min(B.width, B.height * r), th = Math.min(B.height, B.width / r);
      var k = S.width / tw, vis = S.height / k;              /* how much of the photo's height the page crop shows */
      var iy = Math.max((B.height - th) / 2, (B.height - vis) / 2), ix = (B.width - tw) / 2;
      var dx = (S.left + S.width / 2) - (B.left + B.width / 2), dy = (S.top + S.height / 2) - (B.top + B.height / 2);
      var rad = (parseFloat(getComputedStyle(itemEl(i)).borderTopLeftRadius) || 12) / k;
      return [
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + k + ')', clipPath: 'inset(' + iy + 'px ' + ix + 'px round ' + rad + 'px)' },
        { transform: 'translate(0px,0px) scale(1)', clipPath: 'inset(' + ((B.height - th) / 2) + 'px ' + ix + 'px round 0px)' }
      ];
    }
    function chrome(show, ms, delay) {
      $$('.pd-pv__top, .pd-pv__bar', dlg).forEach(function (c) {
        c.animate([{ opacity: show ? 0 : 1 }, { opacity: show ? 1 : 0 }], { duration: ms, delay: delay || 0, easing: show ? IN : OUT, fill: show ? 'backwards' : 'forwards' });
      });
    }
    function growFrom(i, from) {
      if (RM || !from || !dlg.animate) return;
      var S = pageRect(i); if (!S) return;
      var im = $('img', slides[i]);
      dlg.classList.add('is-morph');
      var f = frames(i, S);
      im.animate(f, { duration: 340, easing: IN });
      dlg.animate([{ backgroundColor: 'rgba(18,14,24,0)' }, { backgroundColor: 'rgba(18,14,24,.97)' }], { duration: 300, easing: IN });
      chrome(true, 220, 140);
      setTimeout(function () { dlg.classList.remove('is-morph'); }, 360);
    }
    /* close with motion (X, swipe down); Esc stays instant through the dialog's own close */
    function shut() {
      if (!dlg || !dlg.open || closing) return;
      if (RM || !dlg.animate) { dlg.close(); return; }
      closing = true; reset(false); syncGallery();
      var i = idx, im = $('img', slides[i]), S = pageRect(i);
      var end = function () { dlg.close(); };
      chrome(false, 140, 0);
      var bg = getComputedStyle(dlg).backgroundColor;
      dlg.animate([{ backgroundColor: bg }, { backgroundColor: 'rgba(18,14,24,0)' }], { duration: 240, easing: OUT, fill: 'forwards' });
      if (S && im && im.getAttribute('src')) {
        var f = frames(i, S); f.reverse();
        /* the slide's box already includes any drag offset, so the photo shrinks home from wherever the finger left it */
        im.animate(f, { duration: 260, easing: IN, fill: 'forwards' }).onfinish = end;
      } else {
        track.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, easing: OUT, fill: 'forwards' }).onfinish = end;
      }
    }

    /* zoom: transform on the photo's wrapper; s 1–4, x/y kept so the photo never leaves the screen */
    function zEl() { return $('.pd-pv__zoom', slides[idx]); }
    function bounds(s) {
      var z = zEl(), im = z && $('img', z); if (!im) return { x: 0, y: 0 };
      var W = z.clientWidth, H = z.clientHeight, r = (im.naturalWidth && im.naturalHeight) ? im.naturalWidth / im.naturalHeight : W / H;
      var iw = Math.min(W, H * r), ih = Math.min(H, W / r);
      return { x: Math.max(0, (iw * s - W) / 2), y: Math.max(0, (ih * s - H) / 2) };
    }
    function paintZ(anim) {
      var z = zEl(); if (!z) return;
      z.style.transition = anim && !RM ? 'transform .26s cubic-bezier(.22,1,.36,1)' : 'none';
      z.style.transform = 'translate3d(' + Z.x + 'px,' + Z.y + 'px,0) scale(' + Z.s + ')';
      dlg.classList.toggle('is-zoomed', Z.s > 1.01);
      if (Z.s > 1.6) { var im = $('img', z); if (im && !im.getAttribute('data-hi')) { im.setAttribute('data-hi', '1'); im.setAttribute('srcset', sized(list[idx].src, 2400) + ' 2400w'); } }
    }
    function clampZ() { var b = bounds(Z.s); Z.x = Math.max(-b.x, Math.min(b.x, Z.x)); Z.y = Math.max(-b.y, Math.min(b.y, Z.y)); }
    function reset(anim) { Z.s = 1; Z.x = 0; Z.y = 0; paintZ(anim); }
    function zoomAt(s, fx, fy, anim) { /* fx/fy: point relative to the slide's centre */
      var k = s / Z.s; Z.x = fx - (fx - Z.x) * k; Z.y = fy - (fy - Z.y) * k; Z.s = s; clampZ(); paintZ(anim);
    }
    function rel(t) { var r = slides[idx].getBoundingClientRect(); return { x: t.clientX - r.left - r.width / 2, y: t.clientY - r.top - r.height / 2 }; }
    function gestures() {
      var g = null, lastTap = 0, lastPt = null;
      function dist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
      function mid(a, b) { return rel({ clientX: (a.clientX + b.clientX) / 2, clientY: (a.clientY + b.clientY) / 2 }); }
      track.addEventListener('touchstart', function (e) {
        var t = e.touches;
        if (t.length === 2) {
          e.preventDefault();
          g = { m: 'pinch', d0: dist(t[0], t[1]), s0: Z.s, c0: mid(t[0], t[1]), x0: Z.x, y0: Z.y };
        } else if (t.length === 1) {
          g = { m: Z.s > 1.01 ? 'pan' : 'maybe', sx: t[0].clientX, sy: t[0].clientY, x0: Z.x, y0: Z.y, t0: Date.now(), dx: 0, dy: 0 };
        }
      }, { passive: false });
      track.addEventListener('touchmove', function (e) {
        if (!g) return; var t = e.touches;
        if (g.m === 'pinch' && t.length === 2) {
          e.preventDefault();
          var s = Math.max(0.85, Math.min(4, g.s0 * dist(t[0], t[1]) / g.d0)), c = mid(t[0], t[1]);
          Z.s = s; Z.x = c.x - (g.c0.x - g.x0) * (s / g.s0); Z.y = c.y - (g.c0.y - g.y0) * (s / g.s0);
          if (s >= 1) clampZ(); paintZ(false); return;
        }
        if (t.length !== 1) return;
        g.dx = t[0].clientX - g.sx; g.dy = t[0].clientY - g.sy;
        if (g.m === 'pan') { e.preventDefault(); Z.x = g.x0 + g.dx; Z.y = g.y0 + g.dy; clampZ(); paintZ(false); return; }
        if (g.m === 'maybe' && Math.abs(g.dy) > 12 && Math.abs(g.dy) > Math.abs(g.dx) * 1.3) g.m = g.dy > 0 ? 'drop' : 'none';
        else if (g.m === 'maybe' && Math.abs(g.dx) > 12) g.m = 'none';
        if (g.m === 'drop') { e.preventDefault(); dlg.classList.add('is-dragging'); track.style.transform = 'translateY(' + Math.max(0, g.dy) + 'px)'; dlg.style.setProperty('--pd-pv-fade', String(Math.max(0.35, 1 - g.dy / 420))); }
      }, { passive: false });
      track.addEventListener('touchend', function (e) {
        if (!g) return;
        if (g.m === 'pinch') {
          if (e.touches.length === 1) { var t1 = e.touches[0]; g = { m: Z.s > 1.01 ? 'pan' : 'none', sx: t1.clientX, sy: t1.clientY, x0: Z.x, y0: Z.y, t0: Date.now() }; }
          if (Z.s < 1.05) reset(true); else { clampZ(); paintZ(true); }
          if (!e.touches.length) g = null;
          return;
        }
        if (g.m === 'drop') {
          /* [R9-5] a quick flick closes as surely as a long drag (speed, not just distance) */
          var v = g.dy / Math.max(1, Date.now() - g.t0);
          dlg.classList.remove('is-dragging');
          if (g.dy > 110 || (g.dy > 30 && v > 0.3)) { dlg.style.removeProperty('--pd-pv-fade'); shut(); }
          else { track.style.transform = ''; dlg.style.removeProperty('--pd-pv-fade'); }
          g = null; return;
        }
        var moved = Math.abs(g.dx || 0) + Math.abs(g.dy || 0), now = Date.now();
        if (moved < 10 && now - g.t0 < 300) {
          var p = rel({ clientX: g.sx, clientY: g.sy });
          if (now - lastTap < 320 && lastPt && Math.hypot(p.x - lastPt.x, p.y - lastPt.y) < 40) {
            e.preventDefault();
            if (Z.s > 1.01) reset(true); else zoomAt(2.5, p.x, p.y, true);
            lastTap = 0; lastPt = null;
          } else { lastTap = now; lastPt = p; }
        }
        g = null;
      });
      track.addEventListener('touchcancel', function () { if (g && g.m === 'drop') { dlg.classList.remove('is-dragging'); track.style.transform = ''; dlg.style.removeProperty('--pd-pv-fade'); } g = null; });
      w.addEventListener('resize', function () { if (dlg && dlg.open) { reset(false); track.scrollTo({ left: idx * track.clientWidth, behavior: 'auto' }); } });
    }

    /* a tap on a photo or its zoom button, on touch screens only (capture: the theme's zoom never sees it) */
    gal.addEventListener('click', function (e) {
      if (!TOUCH()) return;
      var it = e.target.closest && e.target.closest('.product-gallery-item[data-product-media-type="image"]'); if (!it) return;
      /* [OB-fix 13 Oct 2026] a tap on a control placed on the photo (the Open-the-box dots, their card, "See inside the box") belongs to
         that control, not to the viewer. The theme's zoom element still opens the viewer. */
      var ctl = e.target.closest('button, a, [role="dialog"]'); if (ctl && it.contains(ctl) && !ctl.closest('product-image-zoom')) return;
      var id = it.getAttribute('data-media-id'), i = -1;
      list.forEach(function (p, k) { if (p.id === id) i = k; });
      if (i < 0) return;
      e.preventDefault(); e.stopImmediatePropagation();
      open(i, it);
    }, true);
    list.forEach(function (p) { var z = $('product-image-zoom', p.el); if (z) { z.setAttribute('aria-label', 'Open photo full screen'); } });
  }

  /* ---------- [R8-2] Compare sizes ---------- */
  function compare() {
    var btn = $('[data-pd-cmp]'), data = $('#pd-cmp-data'); if (!btn || !data) return;
    var rows; try { rows = JSON.parse(data.textContent); } catch (e) { return; }
    rows = rows.filter(function (r) { return r && r.g > 0 && r.p > 0; });
    if (rows.length < 2) { btn.hidden = true; return; }
    var me = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || '';
    function per(r) { return Math.round(r.p * 100 / r.g); }
    function money(c) { c = Math.round(c); return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
    function cents(c) { return '$' + (Math.round(c) / 100).toFixed(2); }
    function range(a, b, f) { return a === b ? f(a) : f(a) + '–' + f(b).replace('$', ''); }
    var NAMES = { 250: 'Extra small', 500: 'Small', 1000: 'Large', 1500: 'Extra large' };
    function sizeText(g) { return g >= 1000 ? (g / 1000) + ' kg' : g + ' g'; }
    function short(t) { return String(t || '').replace(/\s+Diwali\s+(Box|Collection)$/i, '').replace(/\s+-\s+Window$/i, '').replace(/\s+Diwali\s+/i, ' '); }
    var groups = {};
    rows.forEach(function (r) { (groups[r.g] = groups[r.g] || []).push(r); });
    var tiers = Object.keys(groups).map(Number).sort(function (a, b) { return a - b; }).map(function (g) {
      var rs = groups[g], ps = rs.map(function (r) { return r.p; }), cs = rs.map(per);
      var range_w = rs.length === 1 && /–|-/.test(rs[0].w || '') ? String(rs[0].w).replace(/approx\.?\s*/i, '').replace(/\s*net.*$/i, '').replace('-', '–').replace(/(\d)\s*(kg|g)$/i, '$1 $2') : sizeText(g);
      return { g: g, name: NAMES[g] || short(rs[0].t), size: range_w, n: rs.length, pMin: Math.min.apply(null, ps), pMax: Math.max.apply(null, ps), cMin: Math.min.apply(null, cs), cMax: Math.max.apply(null, cs), mine: rs.some(function (r) { return r.h === me; }) };
    });
    var best = tiers.reduce(function (a, t) { return !a || t.cMin < a.cMin ? t : a; }, null);
    var dlg = null;
    function build() {
      dlg = el('dialog', 'pd-cmp');
      dlg.setAttribute('aria-labelledby', 'pd-cmp-h');
      var trs = tiers.map(function (t) {
        var tags = (t.mine ? '<span class="pd-cmp__tag pd-cmp__tag--me">This box</span>' : '') + (t === best ? '<span class="pd-cmp__tag">Lowest per 100 g</span>' : '');
        return '<tr class="' + (t === best ? 'is-best ' : '') + (t.mine ? 'is-me' : '') + '"><th scope="row"><b>' + esc(t.name) + '</b><span>' + esc(t.size) + (t.n > 1 ? ' · ' + t.n + ' boxes' : '') + '</span>' + (tags ? '<span class="pd-cmp__tags">' + tags + '</span>' : '') + '</th>'
          + '<td>' + range(t.pMin, t.pMax, money) + '</td><td><b>' + range(t.cMin, t.cMax, cents) + '</b></td></tr>';
      }).join('');
      var all = rows.slice().sort(function (a, b) { return per(a) - per(b); }).map(function (r) {
        var mine = r.h === me;
        return '<li' + (mine ? ' class="is-me"' : '') + '><a href="/products/' + encodeURIComponent(r.h) + '"' + (mine ? ' aria-current="page"' : '') + '>'
          + (r.i ? '<img src="' + esc(r.i) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="pd-cmp__ph"></span>')
          + '<span class="pd-cmp__n"><b>' + esc(short(r.t)) + '</b><span>' + esc(sizeText(r.g)) + ' · ' + money(r.p) + (r.a ? '' : ' · sold out') + (mine ? ' · this box' : '') + '</span></span>'
          + '<span class="pd-cmp__c">' + cents(per(r)) + '<small>per 100 g</small></span></a></li>';
      }).join('');
      dlg.innerHTML = '<div class="pd-cmp__head"><h2 id="pd-cmp-h">Compare sizes</h2><button type="button" class="pd-cmp__x" aria-label="Close">' + X_ICON + '</button></div>'
        + '<div class="pd-cmp__body"><p class="pd-cmp__lede">About-prices per 100 g, worked out from each box’s approximate net weight.</p>'
        + '<div class="pd-cmp__tablewrap"><table class="pd-cmp__table"><thead><tr><th scope="col">Size</th><th scope="col">Price</th><th scope="col">Per 100 g</th></tr></thead><tbody>' + trs + '</tbody></table></div>'
        + '<details class="pd-cmp__all"><summary>Every Diwali box, by price per 100 g <span>(' + rows.length + ')</span></summary><ol>' + all + '</ol></details></div>'
        + '<div class="pd-cmp__foot"><button type="button" class="button button--solid pd-cmp__done">Done</button></div>';
      d.body.appendChild(dlg);
      /* [R9-1] the sheet slides away (0.24 s) instead of vanishing; Esc stays instant */
      var soft = function () {
        if (!dlg.open || dlg.classList.contains('is-closing')) return;
        if (RM) { dlg.close(); return; }
        dlg.classList.add('is-closing');
        var t = setTimeout(fin, 320);
        function fin() { clearTimeout(t); dlg.removeEventListener('animationend', onEnd); dlg.classList.remove('is-closing'); if (dlg.open) dlg.close(); }
        function onEnd(e) { if (e.target === dlg) fin(); }
        dlg.addEventListener('animationend', onEnd);
      };
      $('.pd-cmp__x', dlg).addEventListener('click', soft);
      $('.pd-cmp__done', dlg).addEventListener('click', soft);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) soft(); }); /* tap on the dimmed backdrop */
      dlg.addEventListener('close', function () { lockPage(false); try { btn.focus({ preventScroll: true }); } catch (e) {} });
    }
    btn.addEventListener('click', function () {
      if (!dlg) build();
      lockPage(true); dlg.showModal();
      var h = $('#pd-cmp-h', dlg); h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true });
    });
  }

  function run() { safe(viewer); safe(compare); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run); else run();
})();
